import { useMainMachine } from '../../../utils/useMainMachine';

import { Button } from '../basic-ui/Button';
import { Spinner } from '../basic-ui/Spinner';
import { ACTIONS } from '../../../state';
import { GENERATING } from '../../constants';

import SparklesIcon from '@crazyegginc/hatch/dist/images/icon-sparkles-filled.svg?react';

export function Generate() {
  const { machine, useSelector } = useMainMachine();
  const voice = useSelector(({ context }) => context.voice);
  const hasAIClient = useSelector(({ context }) => Boolean(context.ai));
  const isGenerating = useSelector((state) => state.hasTag(GENERATING));

  return (
    <Button
      disabled={isGenerating || !hasAIClient}
      onClick={() => machine.send({ type: ACTIONS.GENERATE_FULL_PAGE, voice })}
    >
      <div className="flex items-center space-x-2">
        {!isGenerating ? (
          <>
            <SparklesIcon className="w-4 h-4 fill-current" />
            <span>Generate</span>
          </>
        ) : (
          <>
            <Spinner className="w-4 h-4" />
            <span>Generating...</span>
          </>
        )}
      </div>
    </Button>
  );
}
